export default {
    'app.button.title.copy': 'Copy the response',
    'app.button.title.satisfaction': 'Send satisfaction',
    'app.button.title.dissatisfaction': 'Send dissatisfaction',
    'app.button.title.sendSatisfaction': 'Satisfaction sent',
    'app.button.title.sendDissatisfaction': 'Dissatisfaction sent',
    'app.button.title.source': 'Open source',
    'app.button.title.closeNotification': 'Close notification',
    'app.button.title.send': 'Send',
    'app.button.title.remove': 'Remove',
    'app.button.title.settings': 'Options',
    'app.button.title.openFeedback': 'Open feedback',
    'app.button.title.closeFeedback': 'Close feedback',
    'app.button.title.openChat': 'Open interface',
    'app.button.title.closeChat': 'Close interface',
    'app.button.title.closeDrawer': 'Close drawer',
    'app.button.title.openNotification': 'Open notification(s)',
    'app.button.title.fileQuote': 'Text file',
    'app.button.title.webSiteQuote': 'Website',
    'app.button.title.externalWebSiteQuote': 'External website',
    'app.button.label.newwindow': 'opens in a new window',
    'app.button.label.download': 'downloads the document',
    'app.button.label.goToStartOfConversation': 'Back to the beginning of the conversation',
    "app.img.alt.avatar.neutral": "The chatbot is available",
    "app.img.alt.avatar.presentation": "The chatbot is introducing itself",
    "app.img.alt.avatar.think": "The chatbot is thinking",
    "app.img.alt.avatar.joy": "The chatbot is happy",
    "app.img.alt.avatar.sadness": "The chatbot is sad",
    'app.hidden.text.user': 'User:',
    'app.hidden.text.bot': 'Chatbot:',
    'app.hidden.text.explain.bot': 'You are now in the conversation interface with the chatbot. To ask a question, type it on the keyboard and press the Enter key to submit. After receiving a response, use the Tab key to navigate through the available options. You can access external links, open documents, copy the response, or vote to indicate whether the response was satisfactory or not. To return to the input area or ask other questions, continue to use the Tab key. To close the conversational interface, press the Escape key.',
    'app.hidden.text.progressbar.loading': 'Loading response',
    'app.hidden.text.progressbar.loaded': 'Response loaded',
    'app.hidden.text.dissatisfaction': 'Press tab to navigate to the next suggestions',
};
